// extracted by mini-css-extract-plugin
export default {"mobile":"WHvXYK","message":"w1NUrr","messageMobile":"Qu9n9J","action":"Dc6dg_","showMoreText":"OBYj9t","showMoreButton":"_2XYuDK"};